import { useLayoutEffect } from 'react';
import { useForceUpdate } from '@pushpay/utils';
import useTheme from './use-theme';
const listenersCache = {};
/**
 *  Returns true when the screen size matches the given breakpoint
 */

export function useMediaBreakpoint(breakpoint) {
  var _listener$matches;

  const theme = useTheme();
  const forceUpdate = useForceUpdate();

  function getCachedListener() {
    if (breakpoint === 'NEVER') {
      return null;
    }

    if (!listenersCache[breakpoint]) {
      listenersCache[breakpoint] = window.matchMedia(theme.BREAKPOINTS[breakpoint]);
    }

    return listenersCache[breakpoint];
  }

  const listener = getCachedListener();
  useLayoutEffect(function forceUpdateOnBreakpointChange() {
    if (listener) {
      if (typeof listener.addEventListener === 'function') {
        listener.addEventListener('change', forceUpdate);
        return () => {
          listener.removeEventListener('change', forceUpdate);
        };
      } // Deprecated but needed to support Safari < 14


      listener.addListener(forceUpdate);
      return listener.removeListener(forceUpdate);
    }

    return undefined;
  }, [forceUpdate, listener]);
  return (_listener$matches = listener === null || listener === void 0 ? void 0 : listener.matches) !== null && _listener$matches !== void 0 ? _listener$matches : false;
}
export function useMediaBreakpoints() {
  const mobile = useMediaBreakpoint('MOBILE');
  const tablet = useMediaBreakpoint('TABLET');
  const desktop = useMediaBreakpoint('DESKTOP');
  const wideScreen = useMediaBreakpoint('WIDESCREEN');
  return [mobile, tablet, desktop, wideScreen];
}